import React, { memo, useMemo } from "react";
import get from "lodash/get";
import { getCustomerId, getLoId } from "Common";
import {
  faqData,
  moreFaqData,
  normalPrograms,
} from "LandingPage/BrandNewLandingPage/commonData";
import BrandNewLandingPage from "LandingPage/BrandNewLandingPage";

import type { TypeProfileInfo } from "../../interface";

const LO_ID = getLoId();

const CUSTOMER_ID = getCustomerId();

const IS_GMCC = CUSTOMER_ID === "gmcc";

const DEFAULT_FAQ_INFO = [...faqData, ...moreFaqData];

const moduleManage = [
  {
    id: "basic",
    module: 1,
    title: "Profile information",
  },
  {
    id: "widgets",
    module: 3,
    title: "Manage widgets",
    manage: [
      {
        key: "mortgage",
        name: "Mortgage Rate Calculator",
        describe: "Add lenders to put this widget on your landing page.",
        status: true,
        modalType: "3",
      },
      {
        key: "affordability",
        name: "Affordability Calculator",
        describe:
          "Essential Feature:  Accurately estimates the maximum home borrowers can afford.",
        status: true,
        modalType: "",
      },
    ],
  },
  {
    id: "website",
    module: 4,
    title: "Manage website section",
    manage: [
      {
        key: "FAQs",
        name: "Frequently asked questions",
        describe:
          "Address common questions, reducing customer support inquiries.",
        status: true,
        modalType: "6",
      },
      {
        key: "testimonial",
        name: "Customer testimonials",
        describe:
          "Build trust and credibility, influencing potential clients' decisions.",
        status: false,
        modalType: "4",
      },
    ],
  },
];

const moduleConfig = {
  FAQs: {
    path: "showFAQ",
    defaultValue: true,
  },
  testimonial: {
    path: "showTestimonial",
    defaultValue: false,
  },
  mortgage: {
    path: "showMortgage",
    defaultValue: true,
  },
  affordability: {
    path: "showAffordability",
    defaultValue: true,
  },
};

export interface TypePersonalSiteProps {
  appUrl?: string;
  data: TypeProfileInfo.DTO;
}

/**
 * @name PersonalSite 个人主页
 * @description 迁移至 “LandingPage/BrandNewLandingPage”
 */
const PersonalSite: React.FC<TypePersonalSiteProps> = memo(
  ({ appUrl, data }) => {
    const landing = data?.LandingPageSetUp;
    const paramsInfo = landing?.paramsInfo;
    const showCompany = landing?.showCompanyInfo;

    const newModuleManage = useMemo(
      () =>
        moduleManage.map((module) => {
          if (module.module === 3 || module.module === 4) {
            return {
              ...module,
              manage: module.manage.map((item) => {
                const config = moduleConfig[item.key];
                if (!config) return item;

                return {
                  ...item,
                  status: get(landing, config.path, config.defaultValue),
                };
              }),
            };
          }
          return module;
        }),
      [landing],
    );

    return (
      <BrandNewLandingPage
        mode="edit"
        faqInfo={landing?.faqInfo || DEFAULT_FAQ_INFO}
        paramsInfo={{
          title:
            paramsInfo?.title ||
            `How Do I Empower You to Build Your Solid Financial Foundation?`,
          paramsList: paramsInfo
            ? paramsInfo.paramsList
            : IS_GMCC
            ? paramsInfo
            : normalPrograms,
        }}
        companyInfoDisable={showCompany}
        moduleManage={newModuleManage}
        reviewList={landing?.ReviewsList || []}
        basicInfo={{
          file: data?.Image === "" ? [] : [{ url: data?.Image }],
          firstname: data?.FirstName,
          lastname: data?.LastName,
          nmls: data?.NMLS,
          states: get(landing, "States", []),
          languages: landing?.Languages || [],
          tagsList: get(landing, "TagsList", []),
          popularTags: [
            "I speak Mandarin",
            "Self-Employed borrowers",
            "Bay Area for 10+ years",
          ],
          google: landing?.Google || "",
          yelp: landing?.Yelp,
          linkedin: landing?.Linkedin,
          twitter: landing?.Twitter,
          appLink: landing?.appLink,
          helocLink: landing?.helocLink,
          heloanLink: landing?.heloanLink,
          showHomeEquity: landing?.showHomeEquity,
        }}
        aboutInfo={{
          introduction: data?.Introduction,
          phone: data?.Phone,
          email: data?.LandingPageSetUp?.Email,
          tagline: landing?.tagline || "",
          companyName: landing?.CompanyName,
          companyLink: landing?.companyLink, // ? || data?.bluerete?.Link
          // companyLink: landing?.companyLink || data?.bluerete?.Link, // ?
          banner: landing?.banner,
          companyIntroduction: landing?.companyIntroduction,
          companyAddress: landing?.CompanyAddress,
        }}
        customerid={CUSTOMER_ID}
        loid={LO_ID}
        url={""}
        appurl={appUrl}
        toolstoDisplay={
          '["ratequoter","affordability","celebrity15K","celebrityNoratio"]'
        }
      />
    );
  },
);

export { PersonalSite };
